import { mapValues } from 'lodash';
import { EMI_TYPE } from 'pages/PaymentsPage/PaymentOptions/constants';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { get, isEmpty } from 'lodash';
/* We have a change in the structure of bank tenures. To avoid extensive code
changes until flexi-payments phase 3 work starts, we use this function to
transform the old api to new api.

I've added the sample api calls, old and new, under the api data folder. This
function needs to be removed once we start work on the new design that better
matches the new API structure.
*/
// TODO: emiType here is actually the section_code attribute. We use this in
// the function to determine whether to append the tenure message for interest
// EMI under no cost section. Once the design is migrated to phase 4, we won't
// need this anymore.
export default function transformApi(input, emiType) {
    const emiBanks = input.emi_banks || [];
    let emiSchemes = [];
    let emiSchemeAdjustments = {};
    emiBanks.forEach(detail => {
        const tenures = detail.emi_months_sequence;
        const tenureInMonths = tenures.map(months => {
            return {
                emi_tenure_in_months: Number(months)
            };
        });
        let tenuresUpdatedWithMessage = detail.emi_tenures_detail;
        // Add tenures message of no cost unapplicabele if the current emi section
        // is no cost, and the emi detail section in the response is non-nocost.
        // This is a temporary hack until we start flexi payments phase 5 which
        // takes a bank-first approach at which point we don't have to transform
        // the API call in the first place.
        if (emiType === EMI_TYPE.NO_COST && detail.emi_type !== EMI_TYPE.NO_COST) {
            tenuresUpdatedWithMessage = mapValues(tenuresUpdatedWithMessage, tenureDetail => {
                return Object.assign(tenureDetail, { tenure_message: stringTemplate('emiNoCostDiscountUnavailable') });
            });
        }
        Object.assign(emiSchemeAdjustments, tenuresUpdatedWithMessage);
        emiSchemes = emiSchemes.concat(tenureInMonths);
    });
    return {
        emi_scheme_adjustments: emiSchemeAdjustments,
        emi_schemes: emiSchemes,
        is_flexi_live: get(input, 'is_flexi_live', false)
    };
}
export function getDefaultTenure(input, emiState) {
    if (isEmpty(emiState))
        return;
    const { selectedSection } = emiState;
    const emiBanks = input.emi_banks || [];
    const selectedBank = emiBanks.find(bank => bank.emi_type === selectedSection) || emiBanks[0];
    let monthsSequence = get(selectedBank, 'emi_months_sequence', []);
    monthsSequence.sort((left, right) => Number(left) - Number(right));
    return monthsSequence[0];
}
